(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-video"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.nct-hvideo__playbtn');
    if (!btn) return;
    var url = btn.getAttribute('data-nct-video');
    var isMp4 = btn.getAttribute('data-nct-mp4') === 'true';
    if (!url) return;

    var frame = btn.parentNode;
    var media;
    if (isMp4) {
      media = document.createElement('video');
      media.src = url;
      media.controls = true;
      media.autoplay = true;
      media.playsInline = true;
      media.className = 'nct-hvideo__video';
    } else {
      var embed = url;
      if (url.indexOf('youtube.com/watch?v=') > -1) {
        embed = url.replace('watch?v=', 'embed/') + '?autoplay=1';
      } else if (url.indexOf('youtu.be/') > -1) {
        embed = url.replace('youtu.be/', 'youtube.com/embed/') + '?autoplay=1';
      } else if (url.indexOf('vimeo.com/') > -1) {
        // vimeo.com/ID or vimeo.com/ID/HASH (unlisted — hash must go in ?h=)
        var vm = url.split('vimeo.com/')[1].split('?')[0].split('/');
        embed = 'https://player.vimeo.com/video/' + vm[0] + '?autoplay=1';
        if (vm[1]) embed += '&h=' + vm[1];
      }
      media = document.createElement('iframe');
      media.src = embed;
      media.allow = 'autoplay; encrypted-media; fullscreen';
      media.setAttribute('allowfullscreen', '');
      media.style.position = 'absolute';
      media.style.inset = '0';
      media.style.width = '100%';
      media.style.height = '100%';
      media.style.border = '0';
    }
    frame.innerHTML = '';
    frame.appendChild(media);
    if (window.nctTrack) window.nctTrack('view_item', { media: 'home_video' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-itinerary"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var modal = document.querySelector('[data-nct-pdfgate]');
    if (!modal) return;
    var form = modal.querySelector('[data-nct-pdfgate-form]');
    var body = modal.querySelector('[data-nct-pdfgate-body]');
    var thanks = modal.querySelector('[data-nct-pdfgate-thanks]');
    var thanksLink = modal.querySelector('[data-nct-pdfgate-link]');
    var opener;

    function openModal(btn) {
      opener = btn;
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var first = modal.querySelector('input');
      if (first) first.focus();
    }
    function closeModal() {
      modal.hidden = true;
      document.documentElement.style.overflow = '';
      if (opener && opener.focus) opener.focus();
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-nct-pdfgate-open]')) { openModal(e.target.closest('[data-nct-pdfgate-open]')); return; }
      if (e.target.closest('[data-nct-pdfgate-close]')) { closeModal(); return; }
      if (e.target === modal && !modal.hidden) { closeModal(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });

    if (form) {
      form.addEventListener('submit', function () {
        // Native submit posts the lead into the hidden iframe (emails Dai).
        // In the same user gesture, open the PDF in a new tab.
        var submitBtn = form.querySelector('[data-nct-pdf]');
        var url = submitBtn && submitBtn.getAttribute('data-nct-pdf');
        if (url) {
          window.open(url, '_blank', 'noopener');
          if (thanksLink) thanksLink.href = url;
        }
        if (body) body.hidden = true;
        if (thanks) thanks.hidden = false;
        // allow the iframe post to complete; leave modal open showing the thanks state
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-video-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.nct-pvhero__playbtn');
    if (!btn) return;
    var url = btn.getAttribute('data-nct-video');
    var isMp4 = btn.getAttribute('data-nct-mp4') === 'true';
    if (!url) return;

    var frame = btn.parentNode;
    var media;
    if (isMp4) {
      media = document.createElement('video');
      media.src = url;
      media.controls = true;
      media.autoplay = true;
      media.playsInline = true;
      media.className = 'nct-pvhero__video';
    } else {
      // YouTube/Vimeo embed
      var embed = url;
      if (url.indexOf('youtube.com/watch?v=') > -1) {
        embed = url.replace('watch?v=', 'embed/') + '?autoplay=1';
      } else if (url.indexOf('youtu.be/') > -1) {
        embed = url.replace('youtu.be/', 'youtube.com/embed/') + '?autoplay=1';
      }
      media = document.createElement('iframe');
      media.src = embed;
      media.allow = 'autoplay; encrypted-media; fullscreen';
      media.setAttribute('allowfullscreen', '');
      media.style.position = 'absolute';
      media.style.inset = '0';
      media.style.width = '100%';
      media.style.height = '100%';
      media.style.border = '0';
    }
    frame.innerHTML = '';
    frame.appendChild(media);
    if (window.nctTrack) window.nctTrack('view_item', { media: 'hero_video' });
  });

  } catch(e) { console.error(e); }
})();
})();
